module.exports = __webpack_public_path__ + "media/honey-icons/icon-question-b53891d5.svg";